import React from 'react';
import Header from '../Header';
import Sidebar from '../Sidebar';
import ManualDomainAdd from './ManualDomainAdd';

const ManualDomainAddLayout = () => {
  return (
    <div className="flex h-screen overflow-hidden bg-gray-50 dark:bg-slate-950">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto p-6 dark:bg-slate-950">
          <ManualDomainAdd />
        </main>
      </div>
    </div>
  );
};

export default ManualDomainAddLayout;
